import React from "react";
import { FullRow, Row, Col } from "../../framework/Grid";
import AcquireWebComponent from "../../framework/MaterialUI";
import AudInputField from "../../framework/InputField/InputField";
import { RaisedButton } from "material-ui";
import { isEmpty } from "lodash";
import "../auth.css";
import { uiBuildNumber } from "../../../env";

import Recaptcha from "react-recaptcha";

class ResetPassword extends AcquireWebComponent {
  updateDimensions() {
    this.setState({
      height: window.innerHeight + "px",
      topPadding: (window.innerHeight - 480) / 2 + "px",
      footerTop: (window.innerHeight - 480) / 2 - 20 + "px",
    });
  }

  retrieveSession(session) {
    this.session = JSON.parse(session);
  }

  getTokenAfterLogin() {
    if (this.props.token) {
      return {
        key: "session",
        val: {
          loginTime: new Date(),
          token: this.props.token,
          userId: this.props.userId,
          roleId: this.props.roleId,
          roleName: this.props.roleName,
          tokenExpirationTime: this.props.tokenExpirationTime,
          apiBuildNumber: this.props.apiBuildNumber,
        },
      };
    }
    return null;
  }

  componentWillMount() {
    this.updateDimensions();
    this.setState({
      emailTooltip: undefined,
      email: "",
      captchaReady: false,
    });
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this));
    if (!this.props.apiBuildNumber) {
      this.props.getAPIBuildNumber();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  handleEmailChanged(e, value) {
    this.setState({
      email: value,
    });
  }

  handleSendRecovery(e) {
    e.preventDefault();
    this.props.sendPasswordRecoveryEmail(
      this.state.email,
      this.state.secretKey,
    );
    this.recaptchaInstance.reset();
  }

  onLoadCallback() {
    this.setState({ captchaReady: false, secretKey: undefined });
  }

  verifyCallback(response) {
    this.setState({ captchaReady: true, secretKey: response });
  }

  expiredCallback() {
    this.setState({ captchaReady: false, secretKey: undefined });
  }

  render() {
    const { apiBuildNumber } = this.props;
    const {
      sendRecoveryEmailFailMessage,
      sendRecoveryEmailSuccess,
    } = this.props;
    const hasErrorMessage =
      sendRecoveryEmailFailMessage !== undefined &&
      sendRecoveryEmailSuccess !== true;
    return (
      <Row
        className="login-container"
        style={{ height: this.state.height, paddingTop: this.state.topPadding }}
      >
        <Col
          xs="4"
          sm="4"
          md="4"
          lg="4"
          offsetXs="4"
          offsetSm="4"
          offsetLg="4"
          offsetMd="4"
        >
          <FullRow className="text-center no-padding no-margin-bottom">
            <img
              alt=""
              src="/images/logo.png"
              style={{
                display: "inline-table",
                marginTop: "-12px",
                marginRight: "10px",
                height: "48px",
              }}
            />
          </FullRow>
          {/*
					<FullRow className="text-center no-padding no-margin-bottom" >
								<img alt="" src="/images/logo.png" style={{ display: "inline-table", height: "48px" }} />
								<hr style={{borderTop:"solid 1px #000"}} />
					</FullRow>*/}
          <FullRow className="text-center">
            <div
              key="send-reset-success"
              className="login-form"
              style={{
                display: sendRecoveryEmailSuccess === true ? "block" : "none",
                color: "#000",
              }}
            >
              <div style={{ marginTop: "30px", fontSize: "12pt" }}>
                {" "}
                We've send you a verification email.
              </div>
              <div style={{ marginTop: "30px" }}>
                {" "}
                We sent a recovery link to your email address.
              </div>
              <div style={{ marginBottom: "30px" }}>{this.state.email}</div>
              <hr style={{ color: "#000" }} />
              <div className="text-right">
                <a className="link-with-white" href="/resetpassword">
                  Resend recovery link{" "}
                </a>
                &nbsp;|&nbsp;
                <a className="link-with-white" href="/login">
                  Back to log in
                </a>
              </div>
            </div>
            <div
              key="send-reset-form"
              className="login-form"
              style={{
                display: sendRecoveryEmailSuccess !== true ? "block" : "none",
              }}
            >
              <div className="text-left " style={{ color: "#000" }}>
                <h2>Reset Password</h2>
              </div>
              <div
                style={{ display: hasErrorMessage ? "block" : "none" }}
                className="error-message-box"
              >
                <div style={{ color: "red" }}>
                  {sendRecoveryEmailFailMessage}
                </div>
              </div>
              <div style={{ color: "#000" }} className="text-left">
                We'll send a recovery link to
              </div>
              <AudInputField
                labelTitle=""
                key="usernameInputField"
                toolTipContent={this.state.emailTooltip}
                onChange={(e, value) => this.handleEmailChanged(e, value)}
                initValue={this.state.email}
                hintText="Enter your email"
                style={{ marginBottom: "20px" }}
              />
              <Recaptcha
                sitekey="6LeCRTMUAAAAAHF6VoY2v3rjshzumDH6SFLzeMfR"
                ref={e => (this.recaptchaInstance = e)}
                onloadCallback={this.onLoadCallback.bind(this)}
                verifyCallback={this.verifyCallback.bind(this)}
                expiredCallback={this.expiredCallback.bind(this)}
                render="explicit"
              />
              <RaisedButton
                backgroundColor={"#F56600"}
                labelColor="#FFF"
                key="btn-continue"
                disabled={
                  isEmpty(this.state.email) || this.state.captchaReady === false
                }
                style={{ marginTop: "20px" }}
                onClick={this.handleSendRecovery.bind(this)}
                label="SUBMIT"
              />
              <hr style={{ color: "#000" }} />
              <div className="text-right">
                <a className="link-with-white" href="/login">
                  Back to log in
                </a>
                &nbsp;|&nbsp;
                <a
                  className="link-with-white"
                  href="mailto:AudienceAnywhere@claritas.com"
                >
                  Contact{" "}
                </a>
              </div>
            </div>
          </FullRow>
        </Col>
        <Col xs="12" sm="12" md="12" lg="12">
          {uiBuildNumber && apiBuildNumber && (
            <span
              className="pull-right text-right"
              style={{
                fontSize: "0.6em",
                position: "absolute",
                right: "0",
                top: this.state.footerTop,
              }}
            >
              <small>UI Build #{uiBuildNumber}</small>
              <br />
              <small>API Build #{apiBuildNumber}</small>
            </span>
          )}
        </Col>
      </Row>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/Auth/ResetPassword/index.jsx